// T274 — the footer both on-demand panels were missing.
//
// Each asked the route for `limit=100` — its hard maximum — while the toggle
// beside it carried the true count from the facets. The Archived toggle said
// 378 and the panel held 100: 278 rows the operator could not reach by any
// route through the UI, with nothing on screen to say they existed. A list that
// stops at its limit in silence reads as the whole set.
export default function PanelLoadMore({ shown, total, hasMore, loading, onLoadMore }) {
  if (!hasMore) return null;
  return (
    <div className="mt-3 flex items-center justify-center gap-3">
      <button
        type="button"
        onClick={onLoadMore}
        disabled={loading}
        className="rounded-md border border-slate-700 px-3 py-1.5 text-xs text-slate-300 hover:border-brand-600 hover:text-brand-400 disabled:opacity-50"
      >
        {loading ? 'Loading…' : 'Load more'}
      </button>
      <span className="text-xs text-slate-500 tabular-nums">
        {shown} of {total}
      </span>
    </div>
  );
}
